export const CURRENCY_FILTER_OPTIONS = [
  "ALL",
  "USD",
  "EUR",
  "COP",
  "BRL",
  "MXN",
  "CLP",
  "PEN",
  "PYG",
  "UYU",
  "ARS",
  "HKD",
  "CNY",
  "CRC",
  "GTQ",
  "USDT",
  "USDC",
  "BINANCE_PAY",
] as const;

export type CurrencyFilterValue = (typeof CURRENCY_FILTER_OPTIONS)[number];

export const CURRENCY_BADGE_STYLES: Record<
  string,
  { text: string; bg: string }
> = {
  USD: { text: "text-blue-600 dark:text-blue-400", bg: "bg-blue-50 dark:bg-blue-900/30" },
  EUR: { text: "text-slate-600 dark:text-slate-400", bg: "bg-slate-100 dark:bg-slate-800" },
  COP: { text: "text-emerald-600 dark:text-emerald-400", bg: "bg-emerald-50 dark:bg-emerald-900/30" },
  BRL: { text: "text-amber-600 dark:text-amber-400", bg: "bg-amber-50 dark:bg-amber-900/30" },
  MXN: { text: "text-green-600 dark:text-green-400", bg: "bg-green-50 dark:bg-green-900/30" },
  CLP: { text: "text-sky-600 dark:text-sky-400", bg: "bg-sky-50 dark:bg-sky-900/30" },
  PEN: { text: "text-red-600 dark:text-red-400", bg: "bg-red-50 dark:bg-red-900/30" },
  PYG: { text: "text-rose-600 dark:text-rose-400", bg: "bg-rose-50 dark:bg-rose-900/30" },
  UYU: { text: "text-cyan-600 dark:text-cyan-400", bg: "bg-cyan-50 dark:bg-cyan-900/30" },
  ARS: { text: "text-sky-500 dark:text-sky-400", bg: "bg-sky-100 dark:bg-sky-900/30" },
  HKD: { text: "text-red-600 dark:text-red-400", bg: "bg-red-50 dark:bg-red-900/30" },
  CNY: { text: "text-rose-700 dark:text-rose-400", bg: "bg-rose-100 dark:bg-rose-900/30" },
  CRC: { text: "text-teal-600 dark:text-teal-400", bg: "bg-teal-50 dark:bg-teal-900/30" },
  GTQ: { text: "text-blue-700 dark:text-blue-400", bg: "bg-blue-100 dark:bg-blue-900/30" },
  USDT: { text: "text-indigo-600 dark:text-indigo-400", bg: "bg-indigo-50 dark:bg-indigo-900/30" },
  USDC: { text: "text-indigo-600 dark:text-indigo-400", bg: "bg-indigo-50 dark:bg-indigo-900/30" },
  BINANCE_PAY: { text: "text-amber-600 dark:text-amber-400", bg: "bg-amber-50 dark:bg-amber-900/30" },
};

export const DEFAULT_CURRENCY_BADGE = {
  text: "text-green-600 dark:text-green-400",
  bg: "bg-green-50 dark:bg-green-900/30",
};

/** Card top-right icon color (verified badge), semantic with country/flag. */
export const COUNTRY_ICON_COLORS: Record<string, string> = {
  CO: "text-yellow-500 dark:text-yellow-400",
  COL: "text-yellow-500 dark:text-yellow-400",
  BR: "text-green-600 dark:text-green-400",
  BRA: "text-green-600 dark:text-green-400",
  US: "text-blue-600 dark:text-blue-400",
  USA: "text-blue-600 dark:text-blue-400",
  MX: "text-green-600 dark:text-green-500",
  MEX: "text-green-600 dark:text-green-500",
  AR: "text-sky-500 dark:text-sky-400",
  ARG: "text-sky-500 dark:text-sky-400",
  CL: "text-blue-600 dark:text-blue-400",
  CHL: "text-blue-600 dark:text-blue-400",
  PE: "text-red-600 dark:text-red-400",
  PER: "text-red-600 dark:text-red-400",
  EC: "text-yellow-500 dark:text-yellow-400",
  ECU: "text-yellow-500 dark:text-yellow-400",
  PA: "text-blue-600 dark:text-blue-400",
  PAN: "text-blue-600 dark:text-blue-400",
  PY: "text-red-600 dark:text-red-400",
  PRY: "text-red-600 dark:text-red-400",
  UY: "text-blue-500 dark:text-blue-400",
  URY: "text-blue-500 dark:text-blue-400",
  CN: "text-red-600 dark:text-red-400",
  CHN: "text-red-600 dark:text-red-400",
  HK: "text-red-500 dark:text-red-400",
  HKG: "text-red-500 dark:text-red-400",
  CR: "text-blue-600 dark:text-blue-400",
  CRI: "text-blue-600 dark:text-blue-400",
  GT: "text-blue-600 dark:text-blue-400",
  GTM: "text-blue-600 dark:text-blue-400",
  EUR: "text-blue-600 dark:text-blue-400",
};

export const DEFAULT_ICON_COLOR =
  "text-slate-400 dark:text-zinc-500";

export const DIGITAL_ICON_BG = "bg-teal-500 dark:bg-teal-500";
